import type {
  LocalPqRun,
  PqMarketCatalogueEntry,
  PqMarketProgram,
  PqTestName,
} from '@/features/prequalification/localControl/types'

export function testsOfMarket(market: PqMarketCatalogueEntry): PqTestName[] {
  return market.groups.flatMap((group) => group.tests.map((test) => test.testName))
}

export function runsInMarket(runs: LocalPqRun[], market: PqMarketCatalogueEntry): LocalPqRun[] {
  const testNames = new Set(testsOfMarket(market))
  return runs.filter((run) => testNames.has(run.testName))
}

/** Falls back to the raw id for a market the catalogue doesn't list, or while it is still loading. */
export function marketLabel(markets: PqMarketCatalogueEntry[] | null, market: PqMarketProgram): string {
  return markets?.find((entry) => entry.market === market)?.label ?? market
}
